export default {
  'app.welcome': 'Wilkommen',
  'app.about': 'Uber uns',
}
